import { twJoin } from 'tailwind-merge';
import { tv } from 'tailwind-variants';

/**
 * @todo Mudar o botao para loading qnd estiver carregando algo.
 */
export const useButtonStyles = () => {
  return {
    buttonStyle: tv({
      base: twJoin(
        'w-full py-4 px-6 rounded-3xl',
        'font-semibold text-center outline-none',
        'transition-all duration-300 transform',
        'hover:-translate-y-1 focus:ring-2',
      ),
      variants: {
        color: {
          primary: '',
          secondary: '',
          danger: '',
          success: '',
        },
        variant: {
          contained: twJoin(''),
          outlined: twJoin(''),
        },
        loading: {
          false: '',
          true: 'cursor-progress',
        },
      },
      compoundVariants: [
        {
          variant: 'contained',
          color: 'primary',
          className: twJoin(
            'bg-primary focus:ring-primary focus:ring-offset-2',
            'text-white',
            'disabled:bg-gray-400 disabled:hover:translate-y-0',
          ),
        },
        {
          variant: 'contained',
          color: 'secondary',
          className: twJoin(
            'bg-secondary focus:ring-secondary focus:ring-offset-2',
            'text-white',
            'disabled:bg-gray-400 disabled:hover:translate-y-0',
          ),
        },
        {
          variant: 'contained',
          color: 'danger',
          className: twJoin(
            'bg-red-500 focus:ring-red-500 focus:ring-offset-2',
            'text-white',
            'disabled:bg-gray-400 disabled:hover:translate-y-0',
          ),
        },
        {
          variant: 'contained',
          color: 'success',
          className: twJoin(
            'bg-green-500 focus:ring-green-500 focus:ring-offset-2',
            'text-white',
            'disabled:bg-gray-400 disabled:hover:translate-y-0',
          ),
        },
        {
          variant: 'outlined',
          color: 'primary',
          className: twJoin(
            'text-primary focus:ring-primary',
            'border border-primary',
            'disabled:text-gray-400 disabled:hover:translate-y-0',
          ),
        },
        {
          variant: 'outlined',
          color: 'secondary',
          className: twJoin(
            'text-secondary focus:ring-secondary',
            'border border-gray-300',
            'disabled:text-gray-400 disabled:hover:translate-y-0',
          ),
        },
        {
          variant: 'outlined',
          color: 'danger',
          className: twJoin(
            'text-red-500 focus:ring-red-500',
            'border border-gray-300',
            'disabled:text-gray-400 disabled:hover:translate-y-0',
          ),
        },
        {
          variant: 'outlined',
          color: 'success',
          className: twJoin(
            'text-green-500 focus:ring-green-500',
            'border border-gray-300',
            'disabled:text-gray-400 disabled:hover:translate-y-0',
          ),
        },
      ],
      defaultVariants: {
        color: 'primary',
        variant: 'contained',
        loading: false,
      },
    }),
  };
};
